import actions from './actions'
import mutations from './mutations'
import getters from './getters'

const state = {
  dateRangePickerConfig: {
    shortcuts: [{
      text: 'Last month',
      onClick(picker) {
        const end = new Date()
        const start = new Date()
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
        picker.$emit('pick', [start, end])
      }
    }, {
      text: 'Last 3 months',
      onClick(picker) {
        const end = new Date()
        const start = new Date()
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
        picker.$emit('pick', [start, end])
      }
    },
    {
      text: 'Last year',
      onClick(picker) {
        const end = new Date()
        const start = new Date()
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 365)
        picker.$emit('pick', [start, end])
      }
    },
    {
      text: 'Prev 2 years',
      onClick(picker) {
        const end = new Date()
        const start = new Date()
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 730)
        picker.$emit('pick', [start, end])
      }
    },
    {
      text: 'Prev 3 years',
      onClick(picker) {
        const end = new Date()
        const start = new Date()
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 1095)
        picker.$emit('pick', [start, end])
      }
    },
    {
      text: 'Year to date',
      onClick(picker) {
        const end = new Date()
        const start = new Date(new Date().getFullYear(), 0, 1)
        picker.$emit('pick', [start, end])
      }
    }
    ]
  },
  dateRange: []
}

const module = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}

export default module
